<template>
    <el-container class="layout">
        <el-aside class="layout-nav">
            <el-menu router :collapse="isCollapse" :default-active="activeIndex">
                <div class="logo">运营系统</div>
                <div class="layout-nav-menu">
                    <template v-for="menu of menus">
                        <el-submenu v-if="menu.meta.submenu" :key="menu.path" :index="menu.meta.menuIndex">
                            <template slot="title">
                                <i class="el-icon-menu"></i>
                                <span>{{menu.meta.name}}</span>
                            </template>
                            <template v-for="c of menu.children">
                                <el-submenu
                                        :key="c.path"
                                        v-if="c.meta.submenu"
                                        :index="c.meta.menuIndex">
                                    <template slot="title">{{c.meta.name}}</template>
                                    <el-menu-item
                                            v-for="cc of c.children"
                                            :key="cc.path"
                                            :index="cc.meta.menuIndex"
                                            :route="{name:cc.name}">
                                        {{cc.meta.name}}
                                    </el-menu-item>
                                </el-submenu>

                                <el-menu-item
                                        :key="c.path"
                                        v-else
                                        :index="c.meta.menuIndex"
                                        :route="{name:c.name || c.meta.menuIndex}">{{c.meta.name}}
                                </el-menu-item>
                            </template>
                        </el-submenu>

                        <el-menu-item v-else :key="menu.path" :index="menu.meta.menuIndex"
                                      :route="{name:menu.meta.menuIndex}">
                            <i class="el-icon-menu"></i>
                            <span slot="title">{{menu.meta.name}}</span>
                        </el-menu-item>
                    </template>
                </div>
            </el-menu>
        </el-aside>
        <el-container>
            <el-header class="layout-header">
                <div class="collapse">
                    <el-checkbox v-model="isCollapse"></el-checkbox>
                </div>
                <comp-header/>
            </el-header>
            <el-main class="layout-section">
                <el-breadcrumb v-show="breadcrumb.length" separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item
                            v-for="item of breadcrumb"
                            :key="item.path"
                            :to="item.submenu?'':{ path: item.path }">{{item.name}}
                    </el-breadcrumb-item>
                </el-breadcrumb>
                <router-view class="layout-content"/>

                <form-download/>

            </el-main>
        </el-container>
    </el-container>
</template>
<script>
    import {mapState} from 'vuex'
    import CompHeader from './header'
    import FormDownload from 'components/formDownload'


    export default {
        name: 'home',
        components: {
            CompHeader,
            FormDownload
        },
        data() {
            return {
                isCollapse: false,
                activeIndex: ''
            }
        },
        created() {
            this.activeIndex = this.$route.meta.menuIndex
        },
        computed: {
            ...mapState('login', ['menus']),
            breadcrumb() {
                return this.$route.matched.map(val => ({
                    path: val.path,
                    name: val.meta.name,
                    submenu: val.meta.submenu
                })).filter((val) => !!val.name)
            }
        },
        watch:{
            $route(){
                this.activeIndex = this.$route.meta.menuIndex;
            }
        }
    }
</script>
<style lang="scss" scoped>
    $color: #fff;
    $min-height: 560px;
    .collapse {
        position: relative;
        z-index: 1;
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 1px;
            width: 14px;
            height: 50px;
            background-color: darken($theme-color, 35%);
            border-radius: 0 10px 10px 0;
            cursor: pointer;
        }

        :global(.el-checkbox) {
            position: absolute;
            top: 3px;
            width: 14px;
            height: 50px;
            opacity: 0;
        }
    }

    .layout {
        height: 100vh;
        background-color: $bg-color;
        @media (max-width: $body-min-width) {
            overflow-x: auto;
        }

        &-header {
            position: relative;
            z-index: 2;
            width: 100%;
            height: 50px !important;
            padding: 0;
            background-color: $color;
            box-shadow: $shadow;
        }

        &-nav {
            position: relative;
            z-index: 3;
            overflow-x: hidden;
            width: auto !important;
            background-color: $color;
            box-shadow: $shadow;
            &-menu {
                overflow-x: hidden;
                @extend %scrollbar;
                @extend %scrollbar-hide;
                height: calc(100vh - 50px);
            }
            .iconfont {
                font-size: 22px;
                color: $theme-color;
            }
        }

        &-section {
            position: relative;
            overflow: hidden;
            height: calc(100vh - 50px);
            padding: 0;
            background: url("~images/logo.png") no-repeat center;
        }
        :global(.el-breadcrumb) {
            height: 50px;
            line-height: 50px;
            padding: 0 20px;
            font-size: 16px;
            background-color: #fff;
            border-bottom: 1px solid $theme-color;
        }
        &-content {
            position: relative;
            display: flex;
            flex-flow: column;
            height: calc(100% - 50px);
            //min-height: $min-height - 50px - 50px;
            padding: 20px;
            background-color: #fff;
            overflow-y: auto;
            &::-webkit-scrollbar {
                width: 5px;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 5px;
                background-color: rgba(#000, 0.5);
            }
        }
    }

    .logo {
        height: 50px;
        line-height: 50px;
        padding-left: 64px;
        color: #fff;
        font-size: 24px;
        font-weight: bold;
        background: $theme-color url("~images/logo.png") no-repeat 8px center;
        background-size: 50px auto;
    }
</style>